import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsuarioEmpresaListarModule } from './usuario-empresa-listar/usuario-empresa-listar.module';
import { UsuarioEmpresaDetalharModule } from './usuario-empresa-detalhar/usuario-empresa-detalhar.module';
import { UsuarioEmpresaInserirModule } from './usuario-empresa-inserir/usuario-empresa-inserir.module';
import { UsuarioEmpresaEditarModule } from './usuario-empresa-editar/usuario-empresa-editar.module';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:'', data: { breadcrumb : '' }, loadChildren: () => UsuarioEmpresaListarModule},
    {path:'inserir', data: { breadcrumb: 'Novo Vínculo'}, loadChildren: () => UsuarioEmpresaInserirModule},
    {path:'editar', data: { breadcrumb: 'Editar'}, loadChildren: () => UsuarioEmpresaEditarModule},
    {path:'detalhar', data: { breadcrumb: 'Detalhar'}, loadChildren: () => UsuarioEmpresaDetalharModule},


  ])],
  exports: [RouterModule]
})
export class UsuarioEmpresaRoutingModule { }
